module.exports = __webpack_public_path__ + "static/exterior-3-e31827366de23bb69d03d5d40dbbe7e0.jpg";